import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { KeyValue, KeyValueDefault } from '../models/common';
import { IntegrationInterfaceResponse } from '../models/response';
import { Result } from '../models/common/resultResponse';
import { IIntegrationApi } from './base';
import { IntegrationQueueServiceRequest } from '../models/request';

const baseRoute: string = 'Integration';

export class IntegrationApi extends IIntegrationApi {
  getIntegrIntegrationInterfacesByGuidIntegration(
    request: IntegrationQueueServiceRequest
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(
      `${baseRoute}/integrationintegrationinterfacesbyguidintegration`,
      {
        params: request
      }
    );
  }

  getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domain`);
  }

  getDomainIntegrationType(): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/domainintegrationtype`);
  }

  getDomainService(
    idIntegrationType: number
  ): Promise<AxiosResponse<Result<KeyValueDefault[]>>> {
    return api.get(`${baseRoute}/domainservice`, {
      params: { idIntegrationType }
    });
  }

  getIntegrationIntegrationInterfaces(
    guidIntegrationInterface: string | null
  ): Promise<AxiosResponse<Result<KeyValue[]>>> {
    return api.get(`${baseRoute}/integrationIntegrationInterfaces`, {
      params: { guidIntegrationInterface }
    });
  }

  getIntegrationInterface(
    guidIntegration: string,
    idIntegrationType: number
  ): Promise<AxiosResponse<Result<IntegrationInterfaceResponse[]>>> {
    return api.get(`${baseRoute}/integrationinterface`, {
      params: { guidIntegration, idIntegrationType }
    });
  }
}
